import React, { FC } from 'react';
import s from './offersSection.module.scss';
import { List } from '@components/Pages/ToyPage/OffersSection/List/List';
import { toy } from '@specs/specs';
import { useGetCountStoreItems } from '@services/store/hooks/useGetCountStoreItems';
import { FormattedMessage } from 'react-intl';
import { NumberLoader } from '@components/NumberLoader/NumberLoader';
import { InViewHookResponse } from 'react-intersection-observer';
interface Props {
  blockRef: InViewHookResponse['ref'];
  toyId: toy['id'];
  slug: toy['slug'];
  toyName: toy['name'];
  inView: boolean;
}
export const OffersSection: FC<Props> = ({
  toyId,
  slug,
  toyName,
  inView,
  blockRef
}) => {
  const {
    data: count,
    isLoading: countLoading
  } = useGetCountStoreItems({
    toyId
  });
  const isLoading = countLoading;
  return <div className={s.offersSection} ref={blockRef} data-sentry-component="OffersSection" data-sentry-source-file="OffersSection.tsx">
            <div className={s.offersSection__title}>
                <FormattedMessage id={'toy.page.offers.title'} values={{
        count: () => isLoading ? <NumberLoader digitCount={2} /> : count
      }} data-sentry-element="FormattedMessage" data-sentry-source-file="OffersSection.tsx" />
            </div>
            <div className={s.offersSection__body}>
                <List toyName={toyName} toyId={toyId} slug={slug} inView={inView} data-sentry-element="List" data-sentry-source-file="OffersSection.tsx" />
            </div>
        </div>;
};